export default __webpack_public_path__ + "static/media/Lifeline.934d8649.png";